import Vue from 'vue';

const success = (resolve) => {
  resolve();
};

const failed = (errors, reject) => {
  reject(errors);
};

export default (id, productBundle) => (
  new Promise((resolve, reject) => {
    Vue.$http
      .put(`/product_bundles/${id}`, productBundle)
      .then(() => {
        success(resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/productBundle/update.js